import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { Microsoft360View } from '../models/generated/ziroModels';
import { catchError } from 'rxjs/operators';
import { ZiroModalService } from '../services/ziro-modal.service';
import { ZiroModalPromptModalOptions } from '../../modals/prompt-modal/prompt-modal.component';
import { ZiroIcons } from '../models/ziro-icons.enum';
import { ButtonStyles } from '../../button/button.component';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Injectable()
export class Microsoft360ViewResource {
  private _http = inject(HttpClient);
  private _ziroModalService = inject(ZiroModalService);
  private _translateService = inject(TranslateService);
  private _router = inject(Router);

  get(userPrincipalName: string, tenantId: string): Observable<Microsoft360View> {
    return this._http
      .get<Microsoft360View>(`/services/microsoft/views/tenants/${tenantId}/360-view/${userPrincipalName}`)
      .pipe(
        catchError((err) => {
          return this.handleSecurityGroupLicensingError(err, userPrincipalName);
        }),
      );
  }

  handleSecurityGroupLicensingError(err: any, userPrincipalName: string): Observable<any> {
    if (err && err.status === 422 && err.error.reasonCode === 'USER_LICENSE_ASSIGNMENT_INVALID_STATE') {
      const errorDescription: string = err.error.description;
      const errorParams = errorDescription.match(/\[.*?]/g);
      const options: ZiroModalPromptModalOptions = {
        modalViewProperties: {
          title: 'tkey;microsoft_360.view.license_assignment_error.title',
          promptBody: this._translateService.instant('tkey;microsoft_360.view.license_assignment_error.body', {
            upn: userPrincipalName,
            license: errorParams[0],
            state: errorParams[1],
            error: errorParams[2],
          }),
          icon: ZiroIcons.CIRCLE_EXCLAMATION,
          iconClass: 'text-danger',
          buttons: [
            {
              label: 'tkey;microsoft_360.view.license_assignment_error.return_home',
              buttonClass: ButtonStyles.OUTLINE_PRIMARY,
              dataAutomation: 'return-home-button',
              cb: () => {
                return from(this._router.navigateByUrl('/home'));
              },
            },
          ],
        },
      };
      return this._ziroModalService.openPromptModal(() => options.modalViewProperties, options);
    } else {
      throw err;
    }
  }
}
